export function applyStructurePreview() {
  let structurePreviewModule = null;

  /**
   * load app to show structure preview on desktop
   * @param {boolean} shouldCreateStructurePreview control if we need to create or destroy the application
   * @return {Promise<void>}
   */
  async function loadResponsiveStructurePreview(shouldCreateStructurePreview) {
    if (shouldCreateStructurePreview) {
      structurePreviewModule = (await import('./main.js')).default;
      await structurePreviewModule.createStructurePreviewApp();

    }
    else {
      structurePreviewModule?.removeStructurePreviewApp();
    }
  }

  const mobileBreakpoint = window.matchMedia('(min-width: 991.98px)');
  mobileBreakpoint.addEventListener('change', ({ matches }) => loadResponsiveStructurePreview(matches));
  void loadResponsiveStructurePreview(mobileBreakpoint.matches);
}
